const KNOWN_SEARCH_INSTANCES = [
    "searchCS",
    "searchArticles",
    "searchBlogs",
    "searchReports",
    "searchSpotlight",
    "searchPodcasts",
    "searchViewpoints",
    "searchWebinars",
    "webinarsEvents",
    "webinarsEventsArchive",
    "searchAZ",
    "expertise",
    "searchNewsLanding",
    "searchFinancialNewsLanding",
    "searchInvestorNewsLanding"
];

const clearFilters = (e) => {
    if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
    }

    let searchInstanceFound = false;

    // 1. Find and reset the active Funnelback search instance
    for (const varName of KNOWN_SEARCH_INSTANCES) {
        const instance = window[varName];
        if (instance && instance.search && typeof instance.doSearch === "function") {
            searchInstanceFound = true;

            // Reset facets and pagination
            if (typeof instance.resetFacets === "function") {
                instance.resetFacets();
            } else {
                instance.search.activeFacets = {};
            }

            // Clear date narrowing if present (including Pattern B ge_ and le_ keys)
            if (instance.search.additionalFBParams) {
                delete instance.search.additionalFBParams.fbdate;
                delete instance.search.additionalFBParams.ge_fbdate;
                delete instance.search.additionalFBParams.le_fbdate;
                delete instance.search.additionalFBParams.ge_fbStartDate;
                delete instance.search.additionalFBParams.le_fbEndDate;
            }

            instance.search.startRank = 1;

            // Trigger search with updated empty state
            instance.doSearch(true, true);
            break;
        }
    }

    // 2. Uncheck all filter checkboxes
    document.querySelectorAll(".c-filters input[type=checkbox]").forEach((cb) => {
        cb.checked = false;
        cb.closest("li")?.classList.remove("dropdownActive");
    });

    // 3. Clear date inputs & Pattern B date horizon dropdowns
    document.querySelectorAll(".fbjs-date-from, .fbjs-date-to").forEach((dateInput) => {
        dateInput.value = "";
    });
    document.querySelectorAll(".dropdown-list.date-horizon, [data-date-container]").forEach((container) => {
        container.querySelectorAll("li").forEach((li) => {
            li.classList.remove("dropdownActive");
            li.setAttribute("aria-checked", "false");
        });
        const allLi = container.querySelector('li[data-date-range="all"]');
        if (allLi) {
            allLi.classList.add("dropdownActive");
            allLi.setAttribute("aria-checked", "true");
        }
        const parent = container.closest(".c-filters__dropdown-select");
        const titleBtn = parent?.querySelector(".c-filters__dropdown-title");
        const defTitle = parent?.getAttribute("data-title") || "Date";
        if (titleBtn) titleBtn.innerText = defTitle;
        parent?.classList.remove("dropdownActive");
    });

    // 4. Reset dropdown headers and active classes
    document.querySelectorAll(".c-filters__dropdown-select").forEach((container) => {
        container.classList.remove("dropdownActive");
        const titleBtn = container.querySelector(".c-filters__dropdown-title");
        const defaultTitle = container.getAttribute("data-title");
        if (titleBtn && defaultTitle) {
            titleBtn.innerText = defaultTitle;
        }
    });

    // 5. Clear active facet chips
    const activeFacets = document.querySelector(".c-filters .active-facets");
    if (activeFacets) {
        activeFacets.innerHTML = "";
    }

    // 6. Update results counter badge to 0
    const countBadge = document.querySelector(".c-filters__button--results");
    if (countBadge) {
        countBadge.innerText = "0";
    }

    // 7. If no client-side search instance was active on window, fall back to URL reset
    if (!searchInstanceFound) {
        const currentURL = new URL(window.location.href);
        currentURL.search = "";
        window.history.pushState({}, "", currentURL.toString());
    }
};

const handleFilersButtons = () => {
    const resetButton = document.getElementById("resetFilters");
    const applyButton = document.getElementById("applyFilters");

    if (applyButton) {
        applyButton.addEventListener("click", () => {
            document.body.classList.remove("filters-active");
        });
    }

    if (resetButton && !resetButton._bound) {
        resetButton.addEventListener("click", clearFilters);
        resetButton._bound = true;
    }
};

export default handleFilersButtons;
